"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const iterator_to_array_1 = require("./iterator-to-array");
function min(...things) {
    if (things.length === 1) {
        things = things[0];
    }
    let array = iterator_to_array_1.iteratorToArray(things);
    array.sort();
    return array[0];
}
exports.min = min;
